module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/umbrella-stand/umbrellaStand.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/umbrella-stand/umbrellaStand.png
// module id = 649
// module chunks = 0